import { Badge } from "antd";

import { SecondaryText } from "@/components/Typography/Styled";

import { BADGE_COLORS } from "../../constants";
import { StyledTeamStats, StyledTeamStatsItem } from "../../Styled";
import { ITeamStats } from "../../types";

interface TeamStatsProps {
    stats: ITeamStats;
}

export const TeamStats = ({ stats }: TeamStatsProps) => {
    return (
        <StyledTeamStats>
            <StyledTeamStatsItem>
                <Badge
                    count={stats.total}
                    showZero
                    style={{ backgroundColor: BADGE_COLORS.TOTAL }}
                />
                <SecondaryText>Всього</SecondaryText>
            </StyledTeamStatsItem>
            <StyledTeamStatsItem>
                <Badge
                    count={stats.working}
                    showZero
                    style={{ backgroundColor: BADGE_COLORS.WORKING }}
                />
                <SecondaryText>Працюють</SecondaryText>
            </StyledTeamStatsItem>
            <StyledTeamStatsItem>
                <Badge
                    count={stats.notWorking}
                    showZero
                    style={{ backgroundColor: BADGE_COLORS.NOT_WORKING }}
                />
                <SecondaryText>Не на роботі</SecondaryText>
            </StyledTeamStatsItem>
        </StyledTeamStats>
    );
};
